import React from 'react';
export function Header() {
  return <header className="w-full bg-white py-4 px-6" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qTNfNogUq4WjTs8h1E72vU/TSG_source_rgb_wo_logo_transparent_double_%281%29.png" alt="Shotcraft Golf Logo" className="h-11 w-auto" data-id="element-86" />
      </div>
    </header>;
}